export const isDoctorSelected = (state) => state.entity.doctor;

export const isCenterSelected = (state) => state.entity.center;

export const isCompanySelected = (state) => state.entity.company;
